import React, { Component } from "react";
import BuscaAvancada, {
	BuscaAvancadaContext
} from "../../../components/BuscaAvancada/buscaAvancada.component";
import Input from "../../../components/Input/input.component";
import SelectMulti from "../../../components/SelectMulti/selectmulti.component";

export default class PesquisaAvancadaCentralDoacao extends Component {
	render() {
		const filtro = {
			transacoes: [],
			dataInicial: undefined,
			dataFinal: undefined,
			destino: undefined
		};

		const {
			handleSearch,
			handleReset,
			handlePesquisaSimplificada,
			buttonLabel
		} = this.props;
		return (
			<BuscaAvancada
				buttonLabel={buttonLabel}
				initialValues={filtro}
				handleSearch={handleSearch}
				handleClear={({ resetForm }) => {
					handleReset();
					resetForm();
				}}
				handlePesquisaSimplificada={handlePesquisaSimplificada}
			>
				<BuscaAvancadaContext.Consumer>
					{({ values, handleChange, setFieldValue, resetForm }) => {
						this.resetForm = resetForm;
						return (
							<React.Fragment>
								<div className="row mt-3">
									<div className="col-6 mb-1">
										<label>Tipo de transação</label>
										<SelectMulti
											isMulti
											isClearable
											name="transacoes"
											uniqueKey="value"
											label="label"
											onChange={value => {
												setFieldValue(
													"transacoes",
													value
												);
											}}
											value={values.transacoes || []}
											options={[
												{
													value: "ENTRADA",
													label: "Entrada"
												},
												{
													value: "SAIDA",
													label: "Saída"
												}
											]}
										/>
									</div>
									<div className="col-3 mb-1">
										<label>Data de saída inicial</label>
										<Input
											type="date"
											value={values.dataInicial || ""}
											name="dataInicial"
											onChange={event =>
												setFieldValue(
													"dataInicial",
													event.target.value ||
														undefined
												)
											}
											max={
												values.dataFinal
													? values.dataFinal
													: undefined
											}
										/>
									</div>
									<div className="col-3 mb-1">
										<label>Data de saída final</label>
										<Input
											type="date"
											name="dataFinal"
											value={values.dataFinal || ""}
											onChange={event =>
												setFieldValue(
													"dataFinal",
													event.target.value ||
														undefined
												)
											}
											min={
												values.dataInicial
													? values.dataInicial
													: undefined
											}
										/>
									</div>
									<div className="col-12">
										<label>Destino</label>
										<Input
											onChange={handleChange}
											value={values.destino || ""}
											name="destino"
										/>
									</div>
								</div>
							</React.Fragment>
						);
					}}
				</BuscaAvancadaContext.Consumer>
			</BuscaAvancada>
		);
	}
}
